import {IChildWedlet, IParentWedlet, IWedlet, WEDLET} from "back/edit/wed/wedlets/wedlet";
import {BoxLabel} from "back/edit/wed/wedlets/box/boxTags";
import {BoxWedlet} from "back/edit/wed/wedlets/box/box";
import {IWedletModel} from "back/edit/wed/wedCore";
import {DOM} from "lib/commons/xml/dom";
import {IWedletSingleElt} from "back/edit/wed/wedlets/wedletSingleElt";
import {IJmlNode} from "lib/commons/xml/jml";

/**
 * Affichage d'un label intégrant un compteur de la position de cet élement dans son contexte parent.
 * La position est calculée par rapport aux frères précédents du même modèle de wedlet.
 *
 * <wed:bind eltName="x:y" wedlet="Box">
 *  <box-ctn>
 *    <style>...</style>
 *    <div class="head">
 *      <box-label-counter label="Choix {#}"/>
 *    </div>
 *    <div class="body">
 *      <wed:children/>
 *    </div>
 *  </box-ctn>
 * </wed:bind>
 */
export class BoxLabelCounter extends BoxLabel {

	tpl: ILabelAdjusterPointer;

	configWedletElt(tpl: Element & ILabelAdjusterPointer, wedlet: IWedlet) {
		this.wedlet = wedlet;
		this.tpl = tpl;
		if (!tpl.labelAdjuster) {
			tpl.labelAdjuster = labelAdjust.bind(tpl, wedlet.model, this.buildReplace(tpl));
		}
		(wedlet.wedParent as BoxWedlet).addCustomAdjust(tpl.labelAdjuster);
	}

	refreshBindValue(val: IJmlNode) {
		this.classList.toggle("virtual", this.wedlet.isVirtual());
	}

	protected buildReplace(tpl: Element): (pos: number) => string {
		const label = tpl.getAttribute("label");
		return (pos: number) => {return label.replace(/({#})/, pos.toString())}
	}

}

window.customElements.define("box-label-counter", BoxLabelCounter);

interface ILabelAdjusterPointer extends Element {
	labelAdjuster?: (w: BoxWedlet) => void
}

/** Appelé à chaque changement dans le contexte parent. */
function labelAdjust(this: ILabelAdjusterPointer, model: IWedletModel, labelBuilder: (pos: number) => string, parent: BoxWedlet & IParentWedlet) {
	let counter = 0;
	parent.visitWedletChildren(0, Infinity, (w: IChildWedlet & IWedletSingleElt) => {
		if (w.model.nodeName === model.nodeName && w.model.nodeType === model.nodeType) {
			counter++;
			DOM.findNext(w.element.shadowRoot, null, (n: Node): n is Node => {
				if (n instanceof BoxLabelCounter && n.tpl === this) {
					n.textContent = labelBuilder(counter);
					return true;
				}
				return false;
			});
		}
	}, WEDLET.VISITOPTIONS_includeVirtuals);
}